import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Person } from "@mui/icons-material";
import { Box, useTheme } from "@mui/material";
import { IObjectHistoryDataQualityEventItem, IObjectHistoryDiagnosticEventItem, IObjectHistoryWaterLossEventItem } from "../../queries/object-history/Common";
import { getEventColor } from "./ObjectHistoryUtils";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import type { JSX } from "react";

export type ObjectHistoryEventItemAvatarProps = {
    item: IObjectHistoryDataQualityEventItem | IObjectHistoryDiagnosticEventItem | IObjectHistoryWaterLossEventItem;
    icon: IconProp;
};

export function ObjectHistoryEventItemAvatar({
    item,
    icon
}: ObjectHistoryEventItemAvatarProps): JSX.Element {
    const theme = useTheme();

    return (
        <Box sx={{
            position: "relative",
            color: getEventColor(theme, item)
        }}>
            <FontAwesomeIcon icon={icon} size="2x" />

            {item.manual &&
                <Person
                    fontSize="small"
                    style={{
                        margin: 0,
                        border: `2px solid ${theme.palette.background.paper}`,
                        color: theme.palette.background.paper,
                        borderRadius: "50%",
                        position: "absolute",
                        width: 16,
                        height: 16,
                        right: -8,
                        bottom: 0,
                        backgroundColor: getEventColor(theme, item)
                    }}
                />
            }
        </Box>
    );
}
